export { CategoryV2Container as CategoryV2 } from './container';
